<div class="property-type-control" [formGroup]="form" cdkDrag cdkDragBoundary=".cdk-overlay-container" cdkDragRootElement=".cdk-overlay-pane">
  <div cdkDragHandle class="property-type-header">
    <h1 mat-dialog-title class="dialog-header">{{dialogHeaderText}}</h1>
  </div>
  <div class="property-type-content">
    <div class="form-group">
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input matInput placeholder="Name" formControlName="PropertyTypeName" maxlength="50" autocomplete="off">
        <mat-hint></mat-hint>
        @if (form.hasError('PropertyTypeName') && !form.hasError('required')) {
          <mat-error>
            Please enter a valid Name
          </mat-error>
        }
        @if (form.hasError('required')) {
          <mat-error>
            Name is <strong>required</strong>
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field>
        <mat-label>Airtime Credits Text</mat-label>
        <input matInput placeholder="Airtime Credits Text" formControlName="AirtimeCreditsText" maxlength="50" autocomplete="off">
        <mat-hint></mat-hint>
        @if (form.hasError('AirtimeCreditsText')) {
          <mat-error>
            Please enter a valid Airtime Credits Text
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-group">
      <div class="checkbox-form-group">
        <mat-checkbox formControlName="CanHaveFirstRightOfRefusal" title="Can property offer first right of refusal?">First Right Of Refusal</mat-checkbox>
      </div>
    </div>
    <div class="form-group">
      <div class="checkbox-form-group">
        <mat-checkbox formControlName="CanAppearInWhatsOnCalendar" title="Can activities for this property appear in the What's On calendar?">Can Activities Appear In What's On</mat-checkbox>
      </div>
    </div>
    @if (false) {
      <div class="form-group">
        <div class="checkbox-form-group">
          <mat-checkbox formControlName="IsOnline">Is Digital</mat-checkbox>
        </div>
      </div>
    }
    <div class="form-group">
      <mat-form-field>
        <mat-label>Sort Order</mat-label>
        <input matInput (focus)="$event.target.select()" placeholder="Sort Order" formControlName="SortOrder" type="number" min="0" autocomplete="off" />
      </mat-form-field>
    </div>
    @if (false) {
      <div class="form-group">
        <div class="checkbox-form-group">
          <mat-checkbox formControlName="Disabled">Disabled</mat-checkbox>
        </div>
      </div>
    }
  </div>
  <div class="property-type-footer">
    <hr />
    <mat-dialog-actions>
      <div class="button-row">
        <button mat-button (click)="onCancelClick()">Close</button>
        <button mat-button color="primary" [disabled]="!form.valid || !form.dirty || saveInProgress" (click)="onSave()">Save</button>
      </div>
    </mat-dialog-actions>
  </div>
</div>
